import { Select } from 'antd';
import useFetchEntities from 'hooks/useFetchEntities';

const { Option } = Select;

const TeamMultiSelector = ({ value, onChange }) => {
  const { data: teams, loading: teamsLoading } = useFetchEntities('Team', { 
    onlyAttributes: ['teamId', 'name', 'logoUrl'] 
  });

  const handleTeamChange = (selectedTeamIds) => {
    // Limit to maximum 2 teams
    const limitedSelection = selectedTeamIds.slice(0, 2);
    onChange(limitedSelection);
  };

  return (
    <Select
      mode="multiple"
      placeholder="Select teams (max 2)"
      showSearch
      optionFilterProp="label"
      style={{ width: 300 }}
      value={value}
      onChange={handleTeamChange}
      loading={teamsLoading}
      maxTagCount={2}
      maxTagTextLength={20}
    >
      {teams?.map((team) => (
        <Option key={team.teamId} value={team.teamId} label={team.name}>
          <div className="flex items-center gap-2">
            {team.logoUrl && (
              <img 
                src={team.logoUrl.replace("[size]", "cropped_sm")} 
                alt={team.name}
                className="w-4 h-4 object-contain"
              />
            )}
            <span>{team.name}</span>
          </div>
        </Option>
      ))}
    </Select>
  );
};

export default TeamMultiSelector;
